import { render } from "./GlobalOutroView.vue?vue&type=template&id=d800ae6e&scoped=true"
import script from "./GlobalOutroView.vue?vue&type=script&lang=js"
export * from "./GlobalOutroView.vue?vue&type=script&lang=js"

import "./GlobalOutroView.vue?vue&type=style&index=0&id=d800ae6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d800ae6e"]])

export default __exports__